import { gate } from 'hub-http/gates';
export const SECURITY_ANNOTATION_MIGRATION_GATE = gate('MultiAccountManagement:SecurityAnnotationMigration');
export const ORG_CONFIG_REDESIGN_GATE = gate('MultiAccountManagement:OrgConfigRedesign');